define('plugin/paid-attributes/view/step/AttributeLayout',['require','lib/view/LayoutView'],function (require) {

	var Parent = require('lib/view/LayoutView');
	
	/**
	 * Default datetime step layout
	 * 
	 * @class AttributeLayout
	 */
	return Parent.extend({
	
	    template: '#paid_attribute_step_layout',
	    
	    regions: {
			content: '#sb_content',
			sidebar: '#sb_sidebar_container',
			totals: '#sb_attribute_totals',
	    },

		ui: {
			'next': '.sb-next'
		},

		triggers: {
			'click @ui.next': 'go:next'
		},

	    getContentRegion: function () {
	    	return this.content;
	    },
	    
        getSideBarRegion: function () {
	    	return this.sidebar;
		},

        getTotalsRegion: function () {
	    	return this.totals;
		},

        supportsSidebar: function () {
			//TODO any conditions?
			return true;
		},
        
        initialize: function () {
            Parent.prototype.initialize.apply(this);
            
            this._paidAttributeCollection = this.getOption('paidAttributeCollection');
            this.listenTo(this._paidAttributeCollection, 'sync', this._updateVisibility);
        },
        
        _updateVisibility: function () {
            this.$el.show();
        },

		serializeData: function () {
			return _.extend(
				Parent.prototype.serializeData.apply(this), {
                    emptyCollection: this._paidAttributeCollection.length == 0,
                    supports_sidebar: this.supportsSidebar()
				}
			);
        },
        
        onDomRefresh: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'paid_attributes'
			});
		}
	    
	});

});
